import { styled, css } from 'styled-components';

export const Container = styled.div`
  cursor: pointer;
  height: 34px;
  left: 0;
  position: absolute;
  top: 0;
  width: 34px;
  z-index: 1;

  * {
    box-sizing: border-box;
  }
`;

export const List = styled.ul`
  ${({ theme: { colors } }) => css`
    background: ${colors.brandLight};
    box-shadow:
      0 0 0 1px ${colors.brandDarkTint80},
      0 0.75rem 0.5rem -0.25rem ${colors.brandDarkAlpha15},
      0 0.25rem 0.25rem -0.125rem ${colors.brandDarkAlpha20};
    border-radius: 0.275rem;
    margin: 0;
    padding: 0.5rem 0.5rem 0.5rem;
    width: max-content;
    outline: unset;
  `}
`;

export const Option = styled.button<{ $hasExtraLabel: boolean }>`
  ${({ theme: { borderRadius, colors }, $hasExtraLabel }) => css`
    all: unset;
    align-items: center;
    border-radius: ${borderRadius.sm};
    box-sizing: border-box;
    color: ${colors.brandDark};
    cursor: pointer;
    display: flex;
    gap: 0.5rem;
    padding: 0.175rem 0.5rem;
    width: 100%;

    ${
      $hasExtraLabel &&
      css`
        padding-bottom: 0.5rem;
        padding-top: 0.5rem;

        & .text:nth-child(1) {
          line-height: 1.125rem;
        }

        & .text:nth-child(2) {
          line-height: 1rem;
        }
      `
    }

    .icon {
      height: 1.25rem;
      width: 1.25rem;
    }

    &:hover:not([disabled]) {
      background: ${colors.brandPrimaryAlpha10};

      .text {
        color: ${colors.brandPrimary};
      }
    }

    &:focus {
      outline: 2px solid ${colors.brandPrimaryAlpha60};
    }

    &:disabled {
      cursor: default;

      p {
        color: ${colors.brandDarkTint50};
      }
    }
  `}
`;

export const Labels = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
`;

export const Spacer = styled.hr`
  ${({ theme: { colors } }) => css`
    background-color: ${colors.brandDarkTint80};
    border: 0;
    display: block;
    height: 1px;
    margin: 0.5rem 0 0.5rem -0.5rem;
    width: calc(100% + 1rem);
  `}
`;
